<template>
  <div class="text-center">
    <v-card>
      <v-container>
        <v-row justify="center">
          <v-col cols="9">
            <h1 class="text-center">Profil uživatele</h1>
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.firstName"
                      :rules="[rules.required]"
                      label="Jméno"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.lastName"
                      :rules="[rules.required]"
                      label="Příjmení"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.email"
                      :rules="[rules.required, rules.email]"
                      label="E-mail"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone1"
                      :rules="[rules.required, rules.phone]"
                      label="Telefon"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone2"
                      :rules="[rules.phone]"
                      label="Telefon 2"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone3"
                      :rules="[rules.phone]"
                      label="Telefon 3"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.password"
                      :rules="form.id ? [] : [rules.required, rules.minLength(6)]"
                      label="Heslo"
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.passwordConfirmation"
                      :rules="form.id ? [] : [rules.required, formRules.passwordConfirmation]"
                      :type="show2 ? 'text' : 'password'"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                      label="Heslo znovu"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      color="green"
                      v-model="form.street"
                      :rules="[rules.required]"
                      label="Ulice"
                      :disabled="!currentUser.deliveryStreet && !canEditAddresses"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      color="green"
                      v-model="form.streetNumber"
                      :rules="[rules.required]"
                      label="Č. p."
                      :disabled="!currentUser.deliveryStreet && !canEditAddresses"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      color="green"
                      v-model="form.city"
                      :rules="[rules.required]"
                      label="Město"
                      :disabled="!currentUser.deliveryStreet && !canEditAddresses"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      color="green"
                      v-model="form.zip"
                      :rules="[rules.required]"
                      label="PSČ"
                      :disabled="!currentUser.deliveryStreet && !canEditAddresses"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      v-model="form.cityDistrictId"
                      label="Městská část"
                      :items="districts"
                      :disabled="!currentUser.deliveryStreet && !canEditAddresses"
                      item-value="id"
                      item-text="name"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      color="green"
                      v-model="form.description"
                      label="Popis"
                      rows="3"
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      label="Vyberte typ stravy"
                      v-model="form.foodTypes"
                      :items="foodTypes"
                      :search-input.sync="search"
                      item-text="name"
                      hide-selected
                      multiple
                      return-object
                      persistent-hint
                      small-chips
                      deletable-chips
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>

                <v-checkbox
                  color="green"
                  v-model="form.delivery"
                  label="Jiná dodací adresa"
                  :disabled="!canEditAddresses"
                ></v-checkbox>

                <div v-if="form.delivery">
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryStreet"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Ulice"
                        :disabled="!canEditAddresses"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryStreetNumber"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Č. p."
                        :disabled="!canEditAddresses"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryCity"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Město"
                        :disabled="!canEditAddresses"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryZip"
                        :rules="form.delivery ? [rules.required] : []"
                        label="PSČ"
                        :disabled="!canEditAddresses"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        color="green"
                        v-model="form.deliveryCityDistrictId"
                        label="Městská část"
                        :disabled="!canEditAddresses"
                        :items="districts"
                        item-text="name"
                        item-value="id"
                        :rules="form.delivery ? [rules.required] : []"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>

                <v-checkbox
                  color="green"
                  v-model="form.company"
                  label="Jsem firma"
                ></v-checkbox>

                <div v-if="form.company">
                  <v-row>
                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.companyName"
                        :rules="form.company ? [rules.required] : []"
                        label="Název"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.ico"
                        :rules="form.company ? [rules.required] : []"
                        label="IČO"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.dic"
                        :rules="form.company ? [rules.required] : []"
                        label="DIČ"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      outlined
                      :items="packagingTypes"
                      label="Způsob balení"
                      v-model="form.preferredCustomPackaging"
                    >
                    </v-select>
                  </v-col>
                  <v-col></v-col>
                </v-row>
                <v-btn
                  :disabled="!formValid"
                  color="warning"
                  class="mr-4"
                  @click="save"
                >
                  Zapsat
                </v-btn>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import rules from '../../mixins/rules'

export default {
  name: 'Profile',
  mixins: [rules],
  data: function () {
    return {
      packagingTypes: [
        {
          text: 'Standardní balení',
          value: false
        },
        {
          text: 'Vlastní nádoba',
          value: true
        }
      ],
      dialog: true,
      show1: false,
      show2: false,
      form: {},
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      },
      formValid: true,
      foodTypes: [],
      districts: [],
      model: ['Vuetify'],
      search: null,
      canEditAddresses: false
    }
  },
  methods: {
    save () {
      this.$http.put(`/users/${this.currentUser.id}`, this.keysToSnakeCase(this.form))
        .then(response => {
          const accessToken = JSON.parse(localStorage.getItem('user')).accessToken
          const newUserData = this.keysToCamelCase(response.data)
          newUserData.accessToken = accessToken
          localStorage.setItem('user', JSON.stringify(newUserData))
          location.reload()
          scrollTo(0, 0)
        })
        .catch(err => {
          scrollTo(0, 0)
          console.log(err)
          if (err.response.status === 422) {
            alert('E-mail je již používán.')
          }
        })
    },
    initialize () {
      this.$http.post('/users/isEditAvailable').then(response => {
        this.canEditAddresses = response.data
      })
      this.$http.get('/admin/city-districts')
        .then(response => {
          this.districts = this.keysToCamelCase(response.data)
            .filter(district => district.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.foodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  created () {
    this.form = {
      ...this.currentUser,
      password: null,
      passwordConfirmation: null,
      delivery: !!this.currentUser.deliveryStreet,
      company: !!this.currentUser.companyName,
      preferredCustomPackaging: !!this.currentUser.preferredCustomPackaging
    }
    this.initialize()
  },
  watch: {
    'form.delivery': function (val) {
      if (!val) {
        this.form.deliveryStreet = null
        this.form.deliveryStreetNumber = null
        this.form.deliveryCity = null
        this.form.deliveryZip = null
        this.form.deliveryCityDistrictId = null
      }
    },
    'form.company': function (val) {
      if (!val) {
        this.form.companyName = null
        this.form.dic = null
        this.form.ico = null
      }
    }
  }
}
</script>

<style scoped>
</style>
